<template>
    <transition name="fade" mode="out-in">
        <div v-if="visible" class="mega-modal" @click.self="hide">
            <div class="card h-100">
                <h5 class="card-header">
                    {{ component.name }}
                    <button type="button" class="close" aria-label="Close" @click="hide">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </h5>
            
                <div v-if="loading" class="loading">
                    <fa-layer class="fa-lg fa-6x">
                        <fa :icon="['fas','cloud']" />
                        <fa :icon="['fal','arrow-down']" class="loading-icon" transform="shrink-9 right-2 down-1" style="color: white;" />
                    </fa-layer>
                </div>

                <template v-else>
                    <div class="assemble">
                        <div class="spread">
                            <div v-for="side in sides" :key="side" 
                                :ref="'side' + side" 
                                :class="[
                                    'side-' + side, 
                                    activeSide == side ? 'active' : '',
                                    isBastard()
                                ]" 
                                :style="heightStyle"
                                @click="setActiveSide(side)">
                            </div>
                        </div>
                        <div class="disposition" :class="{'displace' : start_with_rightside}" >
                            <div v-for="(page,index) in pages" :key="index" 
                                class="disposition-page" 
                                :class="{active : activePage == index+1}"
                                :style="dispositionPage"
                                :data-page="index + 1"
                                @click="setActivePage(index+1)">
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div> 
    </transition>
</template>

<script>
import axios from 'axios';
import store from '~/store'

export default {
    middleware: ['auth'],
    data(){
        return {
            sides: ['left','right'],
            activeSide : null,
            activePage : 1,
            printable_id : null,
            printable : {},
            page_height : 0,
            start_with_rightside: 0,
            ratio : 0,
            pages : [{}]
        }
    },
    metaInfo () {
        return { title: this.$t('assemble') }
    },
    created(){
        if(this.$route.params.id){
            this.printable_id = this.$route.params.id;
            this.fetchData();
        } 
    }, 
    computed: {
        heightStyle(){
            return {
                height : this.page_height + 'px'
            }
        },
        dispositionPage(){
            return {
                'padding-top' : this.ratio + '%'
            }
        }
    },
    methods : {
        isBastard(){
            return this.start_with_rightside ? 'hidden' : '';
        },
        setActiveSide(side){
            this.activeSide = side;
        },
        setActivePage(page){
            let side = 'left';

            if(this.start_with_rightside){
                side = page % 2 == 1 ? 'right' : 'left';
            } else {
                side = page % 2 == 0 ? 'right' : 'left';
            }

            this.activePage = page;
            this.activeSide = side;
            this.activeSpread = side == 'left' ? [page,page++] : [page--,page]

        },
        parsePrintable(){
            let printable_type = this.printable.printable_type;
            this.start_with_rightside = this.printable.printable_type.start_with_rightside;
            this.setPageSize();
        },
        setPageSize(){
            let current_width = this.$refs.sideleft[0].clientWidth;

            let paper_width = this.printable.printable_type.paper_width;
            let paper_height = this.printable.printable_type.paper_height;

            let scale_factor = current_width / paper_width;
            let height = paper_height * scale_factor;
            
            this.page_height = height;
            this.ratio = paper_width/paper_height * 100;
            this.scale_factor =  current_width / paper_width;
        },
        async fetchData(){
            const { data } = await axios.get('/api/printable/' + this.printable_id)
            this.printable = data;

            this.parsePrintable()
        }
    }
}
</script>
<style lang="scss" scoped>

@import '~bootstrap/scss/bootstrap';
.wrapper {
    height: 100%;
}
.assemble {
    max-height: 87vh !important;

    @extend .d-flex;
    
    .spread {
        @extend .d-flex;
        @extend .flex-grow-1;
    }

    .disposition {
        width: 150px;

        &.displace {
            .disposition-page:first-child {
                margin-left: 51%;
            }
            .disposition-page:nth-child(2n) {
                margin-right: 2%!important;
            }
            .disposition-page:nth-child(1n) {
                margin-right: 0;
            }
        }

        &-page {
            background: #fff;
            display: inline-block;
            width: 49%;
            margin-right: 2%;
            border: 1px solid #ccc;
            position: relative;    

            &:nth-child(2n) {
                margin-right: 0;
            }

            &::before {
                @extend .d-flex;
                @extend .justify-content-center;
                @extend .align-items-center;
                
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                content: attr(data-page);
            }
        }
    }

    .side-left,
    .side-right {
        background: #fff;
        width: 49.6%;
        margin-right: .2%;
        border: 1px solid #ccc;
        box-shadow: 0 2px 6px 0 hsla(0,0,0,.05);
    }
    .active {
        border: 1px solid $danger;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/assemble.vue